import { render, staticRenderFns } from "./AdministrarConceptos.vue?vue&type=template&id=1a628c6a&scoped=true&"
import script from "./AdministrarConceptos.vue?vue&type=script&lang=js&"
export * from "./AdministrarConceptos.vue?vue&type=script&lang=js&"
import style0 from "./AdministrarConceptos.vue?vue&type=style&index=0&id=1a628c6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a628c6a",
  null
  
)

export default component.exports